import { FunctionComponent } from "react";
import QuestionSection from './QuestionSection'
import '../../assets/styles.css';
// import flecha from '../../assets/img/flecha.svg'

interface ContainerProps {
    question: any
}

const Question: FunctionComponent<ContainerProps> = (props) => {
    const q = props.question

    return (
        <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 marco">
                <div className="row justify-content-center">
                    <div className="col-2" style={{margin: '0', padding: '0'}}>
                        { q.icon?
                                <img className='img-fluid' src={ q.icon } alt="" />
                        : ''
                        }
                    </div>
                    <div className="col-8">
                        <span className="p"><strong>{ q.title }</strong> { q.detail ?? '' } </span>

                        {q.sections.map( (s: any, index: number) =>
                        <div className="row" key={`${index}_${s.title}`} >
                            <QuestionSection section={s} parentTitle={s.mapEnabled ? q.titleFull : ''}></QuestionSection>
                        </div>
                        )}
                </div>
                </div>
            </div>
        </div>
    )
}
export default Question;
